import { render, staticRenderFns } from "./ShortTermContractor.vue?vue&type=template&id=588fb20b"
import script from "./ShortTermContractor.vue?vue&type=script&lang=js"
export * from "./ShortTermContractor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports